import { createTRPCClient, httpBatchLink } from "@trpc/client";
import { createTRPCQueryUtils } from "@trpc/react-query";
import type { AppRouter } from "@trainrr/api/router";
import { store } from "@/lib/states/store";
import { supabase } from "@/lib/supabase/supabaseClient";
import { queryClient } from "@/lib/utils/queryUtils";

const apiUrl = () =>
  `${import.meta.env.VITE_API_URL ?? "http://127.0.0.1:8790"}/trpc`;

export const trpcVanilla = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: apiUrl(),
      async headers() {
        const { data } = await supabase.auth.getSession();
        const token = data.session?.access_token;
        const orgId = store.getState().session.org?.id ?? null;

        return {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          ...(orgId ? { "x-org-id": orgId } : {}),
        };
      },
    }),
  ],
});

/** Same cache as `trpc.useUtils()` — use in route loaders instead of a raw client call. */
export const trpcUtils = createTRPCQueryUtils({
  client: trpcVanilla,
  queryClient,
});
